import React from "react";
import { useSelector } from "react-redux";
import { formatChurnRate } from "../../../../utils/formatChurnRate";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

const RollingThirtyAttritionRate = ({ qa }) => {
  const { churnRate, tooltip, churnRateChange } = useSelector(
    (state) => state.membershipUnits.membershipUnits.rolling30AttritionRate
  );

  const actualValue = formatChurnRate(churnRate);

  return (
    <div className="content__el">
      <DataDisplay
        label="Rolling 30 Attrition Rate"
        type="percentage"
        showDecimal
        toFixedValue={actualValue > 0 ? 2 : undefined}
        value={actualValue}
        disableAnimation={qa}
        toolTipContent={tooltip}
        toolTipId="rollingThirtyAttritionRateToolTip"
        changeProps={{
          changeValue: churnRateChange,
          toolTip: "Percentage change from previous month",
          showBorder: true,
          positiveColor: "#c7343e",
          negativeColor: "#21e981"
        }}
      />
    </div>
  );
};

export default RollingThirtyAttritionRate;
